import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const InvestmentSectors = () => {
  const sectors = [
    {
      image: '/images/man-8575459_640.jpg',
      title: 'Cryptocurrency Investment',
      description: 'Get paid through our strategic investment management system designed for digital assets. Our expert team provides tailored investment strategies to maximize your returns.',
      route: '/sectors/cryptocurrency'
    },
    {
      image: '/images/money-5029288_1280.jpg',
      title: 'Loans and Grants',
      description: 'Access easy financing options with our streamlined loan process. We provide flexible loan offers for dedicated members and investors with competitive rates.',
      route: '/sectors/loans-and-grants'
    },
    {
      image: '/images/chart-1905224_640.jpg',
      title: 'Stock or Share',
      description: 'Navigate the stock market with our expert guidance and investment strategies. Our advisors help you build a diversified portfolio aligned with your financial goals.',
      route: '/sectors/stocks'
    },
    {
      image: '/images/refinery-3613526_1280.jpg',
      title: 'Oil and Gas',
      description: 'Explore investment opportunities in the energy sector with our specialized oil and gas portfolio options. We provide insights into this valuable commodity market.',
      route: '/sectors/oil-and-gas'
    },
    {
      image: '/images/sa-rapita-2483668_640.jpg',
      title: 'Real Estate',
      description: 'Build wealth through property investments. Access commercial, residential, and REIT opportunities for diversified exposure.',
      route: '/sectors/real-estate'
    }
  ];

  return (
    <section id="investment-sectors" className="py-20 bg-gradient-to-br from-navy-50 via-blue-50 to-indigo-50 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-32 h-32 bg-gold-400 rounded-full opacity-20"></div>
        <div className="absolute bottom-20 right-10 w-48 h-48 bg-navy-400 rounded-full opacity-15"></div>
        <div className="absolute top-1/2 left-1/3 w-24 h-24 border-2 border-gold-400 rounded-full opacity-30"></div>
      </div>
      <div className="relative z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16" data-aos="fade-up">
          <h2 className="text-4xl md:text-5xl font-bold font-serif text-navy-900 mb-6">
            Our Investment
            <span className="text-gradient block">Sectors</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Explore our comprehensive range of investment sectors designed to diversify 
            your portfolio and maximize growth potential across different asset classes.
          </p>
        </div>

        {/* Sectors Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {sectors.map((sector, index) => {
            return (
              <div
                key={index}
                className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:-translate-y-1 overflow-hidden"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                {/* Image */}
                <div className="relative h-48 mb-6 rounded-xl overflow-hidden group-hover:scale-105 transition-transform duration-300">
                  <img
                    src={sector.image}
                    alt={sector.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy-900/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>

                {/* Content */}
                <h3 className="text-2xl font-bold text-navy-900 mb-4 group-hover:text-gold-600 transition-colors">
                  {sector.title}
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {sector.description}
                </p>

                {/* CTA */}
                <Link
                  to={sector.route}
                  className="group/btn inline-flex items-center text-gold-600 font-semibold hover:text-gold-700 transition-colors"
                >
                  Learn More
                  <ArrowRight className="ml-2 h-4 w-4 group-hover/btn:translate-x-1 transition-transform" />
                </Link>
              </div>
            );
          })}
        </div>


        </div>
      </div>
      
      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden">
        <svg className="relative block w-full h-32" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <defs>
            <linearGradient id="sectorsWaveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" style={{stopColor: '#fffbeb', stopOpacity: 1}} />
              <stop offset="25%" style={{stopColor: '#fef3c7', stopOpacity: 1}} />
              <stop offset="50%" style={{stopColor: '#fde68a', stopOpacity: 1}} />
              <stop offset="75%" style={{stopColor: '#93c5fd', stopOpacity: 1}} />
              <stop offset="100%" style={{stopColor: '#3b82f6', stopOpacity: 1}} />
            </linearGradient>
          </defs>
          <path 
            d="M0,0 C400,120 800,20 1200,80 L1200,120 L0,120 Z" 
            fill="url(#sectorsWaveGradient)"
          />
          <path 
            d="M0,40 C200,0 400,100 600,60 C800,20 1000,100 1200,50 L1200,120 L0,120 Z" 
            fill="url(#sectorsWaveGradient)"
            opacity="0.7"
          />
          <path 
            d="M0,80 C300,40 600,120 900,70 C1050,40 1150,90 1200,60 L1200,120 L0,120 Z" 
            fill="url(#sectorsWaveGradient)"
            opacity="0.5"
          />
        </svg>
      </div>
    </section>
  );
};

export default InvestmentSectors; 